import { eventBus, Events } from '../core/EventBus.js';
import { gameState } from '../core/GameState.js';
import { JUICE } from '../core/Constants.js';

const $ = (id) => document.getElementById(id);

export class HUD {
  constructor() {
    this.el = {
      score: $('score'), lives: $('lives'), level: $('level'),
      start: $('start-screen'), over: $('game-over-screen'),
      finalScore: $('final-score'), best: $('best-score'),
      banner: $('banner'), flash: $('flash'), mute: $('mute-indicator'),
      startBtn: $('start-btn'), restartBtn: $('restart-btn'),
      muteBtn: $('mute-btn'),
    };

    this.el.startBtn?.addEventListener('click', (e) => {
      e.target?.blur();
      window.focus();
      eventBus.emit(Events.INPUT_START);
    });
    this.el.start?.addEventListener('click', (e) => {
      if (e.target.closest('#config-panel') || e.target.closest('#config-btn') || e.target.closest('#mute-btn')) return;
      window.focus();
      eventBus.emit(Events.INPUT_START);
    });
    this.el.restartBtn?.addEventListener('click', (e) => {
      e.target?.blur();
      window.focus();
      eventBus.emit(Events.INPUT_START);
    });
    this.el.muteBtn?.addEventListener('click', () => eventBus.emit(Events.INPUT_MUTE));

    this.unsub = [
      eventBus.on(Events.SCORE_CHANGE, () => this.sync()),
      eventBus.on(Events.LIVES_CHANGE, () => this.syncLives()),
      eventBus.on(Events.LEVEL_CHANGE, () => this.sync()),
      eventBus.on(Events.GAME_START, () => this.onStart()),
      eventBus.on(Events.GAME_OVER, () => this.onGameOver()),
      eventBus.on(Events.LEVEL_COMPLETE, (d) => {
        const kidMsg = d.intactKids > 0
          ? `  (KIDS BONUS +${d.kidBonus}! +1 CHILD JOINED!)`
          : '  (+1 CHILD JOINED!)';
        this.showBanner(`LEVEL ${d.level} CLEAR  +${d.bonus}${kidMsg}`);
      }),
      eventBus.on(Events.FLASH, () => this.doFlash()),
      eventBus.on(Events.AUDIO_TOGGLE, ({ muted }) => this.syncMute(muted)),
      eventBus.on('curry:immunity', ({ duration }) => {
        this.showBanner(`SPICY IMMUNITY! (${duration.toFixed(1)}s)`);
      }),
      eventBus.on('curry:poison', ({ duration }) => {
        this.showBanner(`CURRY POISONED! SLOWED (${duration.toFixed(1)}s)`);
      }),
    ];

    this.sync();
    this.syncMute(false);
  }

  sync() {
    const r = gameState.run;
    this.el.score.textContent = String(r.score).padStart(5, '0');
    this.el.level.textContent = r.level;
    this.syncLives();
  }

  syncLives() {
    const n = Math.max(0, gameState.run.lives);
    this.el.lives.textContent = n > 0 ? '♥'.repeat(n) : '—';
  }

  syncMute(muted) {
    if (this.el.muteBtn) this.el.muteBtn.textContent = muted ? 'SOUND OFF' : 'SOUND ON';
  }

  onStart() {
    this.el.start.classList.add('hidden');
    this.el.over.classList.add('hidden');
    this.sync();
  }

  onGameOver() {
    const r = gameState.run;
    this.el.finalScore.textContent = String(r.score).padStart(5, '0');
    this.el.best.textContent = String(r.best).padStart(5, '0');
    this.el.over.classList.remove('hidden');
  }

  showBanner(text) {
    const b = this.el.banner;
    b.textContent = text;
    b.classList.remove('show');
    void b.offsetWidth; // restart the CSS animation
    b.classList.add('show');
  }

  doFlash() {
    const f = this.el.flash;
    f.style.transition = 'none';
    f.style.opacity = '0.85';
    requestAnimationFrame(() => {
      f.style.transition = `opacity ${JUICE.LEVEL_FLASH}s ease-out`;
      f.style.opacity = '0';
    });
  }

  dispose() { this.unsub.forEach((u) => u()); }
}
